import React from "react";
import { withRouter } from "react-router-dom";
import EntertainmentDetails from "../../components/EntertainmentDetails";

function Entertainment({ buscaAtual }) {
	return (
		<div style={{ backgroundColor: "#f2f2f2" }}>
			<EntertainmentDetails buscaAtual={buscaAtual} />
		</div>
	);
}

export default withRouter(Entertainment);
